import { Button } from "@mui/material";
import * as React from "react";

import type { SharedButtonProps } from "./types";
/**
 * It renders a button from @mui/material
 * https://mui.com/pt/api/loading-button/
 */
export const SharedButton = React.forwardRef<HTMLButtonElement, SharedButtonProps>(
  ({ children, sx, ...props }, ref) => (
    <Button
      variant="outlined"
      size="medium"
      ref={ref}
      sx={{ boxShadow: "none", ...sx }}
      {...props}
    >
      {children}
    </Button>
  ),
);
